class TruncateText extends HTMLElement {
  constructor() {
    super()
    this.originalText = ''
    this.truncatedText = ''
    this.isExpanded = false
    this.size = 0
  }

  static get observedAttributes() {
    return ['data-size']
  }

  connectedCallback() {
    // Store the original HTML content
    this.originalText = this.innerHTML

    // Get the size attribute
    this.size = parseInt(this.dataset.size || '100', 10)

    // Initial render
    this.render()
  }

  render() {
    // Create a temporary div to parse HTML content
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = this.originalText
    const textContent = tempDiv.textContent || tempDiv.innerText

    // If text is short enough, just display the original content
    if (textContent.length <= this.size) {
      this.innerHTML = this.originalText
      return
    }

    if (this.isExpanded) {
      // Show the full content - Important: directly using innerHTML preserves formatting
      this.innerHTML = this.originalText
    } else {
      // We need to truncate, but preserve HTML - this is trickier
      let currentLength = 0

      // Find a good truncation point that doesn't cut in the middle of a word
      const words = textContent.split(' ')
      let truncatedWords = []

      for (const word of words) {
        if (currentLength + word.length + 1 <= this.size) {
          truncatedWords.push(word)
          currentLength += word.length + 1 // +1 for the space
        } else {
          break
        }
      }

      // Create a simplified version with truncated text + Read more
      this.innerHTML = `
          ${truncatedWords.join(' ')}... 
          <a href="#" class="short-text-more text-[17px] underline" aria-expanded="false" aria-label="Read more">read more</a>
        `

      // Add click handler for the link
      const moreLink = this.querySelector('.short-text-more')
      if (moreLink) {
        moreLink.addEventListener('click', this.expandText.bind(this))
      }
    }
  }

  expandText(event) {
    event.preventDefault()
    this.isExpanded = true
    this.classList.add('expanded')
    this.render()
  }
}

if (!customElements.get('truncate-text')) {
  // Register the custom element
  customElements.define('truncate-text', TruncateText)
}
